<template>
  <Modal :open="open" @close="$emit('close')">
    <div class="text-center">
      <h2 class="text-lg font-semibold text-gray-900">Demander le mandat de prélèvement</h2>
    </div>
    <FormField id="email" label="Email" name="email" placeholder="john@doe.com" v-model="email" />
    <div class="flex justify-end space-x-4 mt-3">
      <SecondaryButton @click="$emit('close')">Fermer</SecondaryButton>
      <GenericButton @click="$emit('sendEmail', email)" :disabled="!email">Envoyer</GenericButton>
    </div>
  </Modal>
</template>

<script>
import { FormField, Modal, GenericButton, SecondaryButton } from "@estaly/ui";

export default {
  components: { SecondaryButton, GenericButton, Modal, FormField },

  props: {
    open: { type: Boolean, required: true },
    initialEmail: { type: String, default: null },
  },

  data() {
    return {
      email: this.initialEmail,
    };
  },

  watch: {
    open(isOpen) {
      if (isOpen) this.email = this.initialEmail;
    },
    initialEmail(value) {
      this.email = value;
    },
  },
};
</script>
